<template>
    <p>Edit task</p>
</template>

<script>
export default {
    props: ['task'],
}
</script>